import { render, staticRenderFns } from "./Shipment.vue?vue&type=template&id=0b7e04c0"
import script from "./Shipment.vue?vue&type=script&lang=js"
export * from "./Shipment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/maq/Code/skyier/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b7e04c0')) {
      api.createRecord('0b7e04c0', component.options)
    } else {
      api.reload('0b7e04c0', component.options)
    }
    module.hot.accept("./Shipment.vue?vue&type=template&id=0b7e04c0", function () {
      api.rerender('0b7e04c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/checkout/components/physical/Shipment.vue"
export default component.exports